import React, { useEffect, useState} from "react";
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'

import store from "@/redux/store";
import CalenderHelperClass from '@/helpers/CalenderHelper'

import {removeTask} from '@/reducers/CommunicationCycle';

import { BuildingOfficeIcon, CreditCardIcon, UserIcon, UsersIcon } from '@heroicons/react/20/solid'

import { Detail as CustomerCompany } from "@/views/base/company/Detail";
import { Storage } from "@/views/Tenant/Storage";
import { useForm, SubmitHandler } from "react-hook-form"
import  {ICustomer} from "@/models/Customer";
import {FieldHolder} from "@/components/holders/FieldHolder";
import { useNavigate, Link } from "react-router-dom";
import Calender from "./CalenderBase"
import {DayView} from "./DayView"
import Drawer from "@/controllers/Drawer";
import CommentFeed from "./CommentFeed";
import AddEventButtons from "./AddEventButtons"

    import {ProgressBar} from '@adobe/react-spectrum'
    import {Button, defaultTheme, Provider} from '@adobe/react-spectrum';
    
import {addCalenderItem, hideModal, nextActionEvent} from '@/reducers/ModalPopup';    
import {getTasks, saveTask, newTaskEvent, setChangedItems, setUpdate} from '@/reducers/CommunicationCycle';
import DB from "@/models/DB";
import {Dossier} from "@/models/Dossier";

export function Overview({...props}) {
        let firstAction = null;
    let otherActions = [];

    let hasEventHandler = false;
    const [selectedData, setSelectedData] = useState(null);
    const [whoIsOpen, setWhoIsOpen] = useState(0);
  const { register, handleSubmit, watch, reset,    formState, setValue, getValues } = useForm({
      defaultValues: ((props?.item) ? {...props?.item} : {})
      //values: props.data
    })
//setValue('tenant.fields.DROPBOX.baseMap', 'sfd');
function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

   const onSubmit: SubmitHandler<any> = (data) => {
    if(props?.onSaveHandler) {
        props?.onSaveHandler(data);
    }
      
    return false;

    }

   const storeComment = (data) => {
    if(props?.onSaveHandler) {
        props?.onSaveHandler(data);
    }
      
    return false;

    }

 
 const showPreview = (event, item) => {
    event.preventDefault();
    let dossier = null;
    if(item?.dossier) {
        dossier = DB.newModel(item?.dossier, Dossier);
    }
    setSelectedData({data: item, dossier:dossier, click: new Date()});
    
    return false;
  }

 const onKeyDown = (event) => {
     event.stopImmediatePropagation();
    if(event?.type == 'keydown' && event?.key == 'Escape') {
        
        previewClose(event);
    }

    };

 const previewClose = (event) => {
    setSelectedData(null);
    return true;    
  }
//useEffect( () => document.addEventListener("keydown", closePanel), [ props.data ] );    
//useEffect( () => () => {document.removeEventListener("keydown", onKeyDown, false)}, [] );

  const onKeyUpHandler =(event) => {
  }

  const removeEvent =(event, item) => {
      store.dispatch( removeTask(item.data.com_key) );
  }

  const editEvent =(event, item) => {
      
      store.dispatch( addCalenderItem({priorities:props?.priority,onCloseEvent:closeEventHandler, onSaveEvent: onSaveEventHandler, data:selectedData?.data, users: props?.users }) );
      
      return false;
  }

    const closeEventHandler=(event) => {
        
        store.dispatch( hideModal(null) );
        return false;
        }    
        
        const onSaveEventHandler=(data) => {
            store.dispatch( saveTask(data) );
//            if(props?.onSubmitHandler) {
//                props?.onSubmitHandler(event);
//            }
            store.dispatch( hideModal(null) );
        }

    const getCustomer=() => {
        if(selectedData && selectedData?.data &&  selectedData?.data?.dossier && selectedData?.data?.dossier?.customer) {
            return selectedData?.data?.dossier?.customer;
        } else if(selectedData && selectedData?.data && selectedData?.data?.customer) {
            return selectedData?.data?.customer;
        }
         
    }
    
    const getActionMenuButton= () => {
        let data = selectedData?.data;
        let objKeys = Object.keys(data?.nextActions);
        
        objKeys.map( (itemKey) => {
            let actionItem = data.nextActions[itemKey]
            let order = (actionItem?.order) ? ( parseInt(actionItem?.order)-1) : otherActions.length;
            if(order == 0) {
                firstAction = actionItem;
            } else {
                otherActions[order] = actionItem
            }
        })
        
        return buildButtonElements();
    }
  /*  
    <button
      onClick={(event) => actionEvent(event, firstAction)}
      type="button"
      className="relative inline-flex items-center rounded-l-md px-3 py-2 text-sm font-semibold text-white shadow-xs bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 focus:z-10"
    >
      {firstAction.label}
    </button>
*/    
    
    const buildButtonElements = () => {
        
        return (
    <div className="inline-flex rounded-md shadow-xs mr-2">
      <Menu as="div" className="relative -ml-px block">
        <MenuButton className="relative inline-flex items-center rounded-r-md px-2 py-2 text-white ring-gray-300 ring-inset bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 focus:z-10">
          <span className="sr-only">Open options</span>
          <ChevronDownIcon aria-hidden="true" className="size-5" />
        </MenuButton>
        <MenuItems
          transition
          className="absolute right-0 z-10 mt-2 -mr-1 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
        >
          <div className="py-1">
            {otherActions.map((item) => (
              <MenuItem key={item.label}>
              <button
                onClick={(event) => actionEvent(event, item)}
                  className="block px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:text-gray-900 data-focus:outline-hidden"
                >
                  {item.label}
                </button>
              </MenuItem>
            ))}
          </div>
        </MenuItems>
      </Menu>
    </div>
        );
    }
    
    const actionEvent = (event, nextAction) => {
        store.dispatch( nextActionEvent(nextAction) );
        
    }
    

   return (
    <>

    <div className="space-y-1 divide-y divide-gray-900/10">
    {(() => {
        if( props?.calenderSettings?.viewtype == 1 ) {
            return (
                <DayView calenderSettings={props?.calenderSettings} items={props?.items}/>
                );
    } else if(!props?.calenderSettings ||  props?.calenderSettings?.viewtype == 0 ) {
        return (
      <div className="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-1">
       <form className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2" onSubmit={handleSubmit(onSubmit)}>
          <div className="px-4 py-2 sm:p-8">
            <div className="mt-1 space-y-8 pb-12 sm:space-y-0   sm:pb-0">
            
            <Calender 
            {...props}
            setValue={setValue} 
            onSubmitHandler={onSubmit} 
            saveItemHandler={props?.onSaveHandler} 
            onNewItemHandler={props?.onNewItemHandler} 
            getValues={getValues} 
            item={props?.item} 
            items={props?.items}
            priority={props?.priority}
            event_types={props?.event_types}
            calenderSettings={props?.calenderSettings} 
            showPreviewHandler={showPreview}
            selectedDate={props?.selectedDate}
            users={props?.users}
            selectedUsers={props?.selectedUsers}
            />
            </div>
          </div>
        </form>
      </div>)
        }  

        })()}          

      </div>

        <Drawer data={selectedData} type="comcycle" key={ selectedData?.data?.start_at } onCloseHandler={(event) => {previewClose(event)}}>
            <>
            {selectedData?.data?.nextActions && 
                <div className="p-8 w-full bg-white">
                {getActionMenuButton()}
                </div>
            }
            <div className="p-8 w-full bg-white">
            <h1>{selectedData?.data?.name}</h1>
            <div className=" w-full my-5">
          <div className="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt className="text-sm/6 font-medium text-gray-900">Type</dt>
            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{((selectedData?.data?.type) ? props?.trans('event.type_'+selectedData?.data?.type) : "ONBEKEND")}</dd>
          </div>                
          <div className="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt className="text-sm/6 font-medium text-gray-900">Dossier</dt>
            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{((selectedData?.data?.dossier) ? selectedData?.data?.dossier?.name : "GEEN DOSSIER GEKOPPELD")}</dd>
          </div>

          <div className="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt className="text-sm/6 font-medium text-gray-900">Dossier taak</dt>
            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{((selectedData?.data?.task_key && selectedData?.dossier) ? selectedData?.dossier.getTaskByKey(selectedData?.data?.task_key, 'key')?.name : "GEEN DOSSIER TAAK GEKOPPELD")}</dd>
          </div>
          
                          
          <div className="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt className="text-sm/6 font-medium text-gray-900">Klant</dt>
            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{(getCustomer()) ? getCustomer().name : ""}</dd>
          </div>                
          <div className="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt className="text-sm/6 font-medium text-gray-900">Sector</dt>
            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{selectedData?.data?.dossier?.sector?.name}</dd>
          </div>                
            
            <div className="px-4 py-2 sm:grid sm:grid-cols-1 sm:gap-1 sm:px-0">
            <dt className="text-sm/6 font-medium text-gray-900">Omschrijving</dt>
            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0" dangerouslySetInnerHTML={{__html: ((selectedData?.data?.description) ? selectedData?.data?.description.replace(/\n/g, "<br />") : "") }}></dd>
            </div>
            </div>
            
            
  <div className=" w-full my-5">
          <AddEventButtons event_types={props?.event_types} parent={selectedData?.data} users={props?.users}/>
  </div>
  <div className=" w-full my-5">
  <p>Voortgang : {selectedData?.data?.progress}%</p>
  <div className="w-full bg-gray-200 rounded-full ">
    <div className={"bg-blue-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full w-"+selectedData?.data?.progress} > {selectedData?.data?.progress}%</div>
  </div>
    </div>
  <CommentFeed data={selectedData?.data?.reference} itemKey={selectedData?.data?.key} storeCommentHandler={storeComment}/>
            </div>
            <div className="inline-flex items-center">
            {selectedData && CalenderHelperClass.canEdit(selectedData?.data) &&
            <button
              type="button"
              onClick={(event) => editEvent(event, selectedData)}
              className="ml-2 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Aanpassen
            </button>
            }
            {selectedData && CalenderHelperClass.canDelete(selectedData?.data) &&

            <button
              type="button"
              onClick={(event) => removeEvent(event, selectedData)}
              className="ml-2 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Verwijder
            </button>
            }
            </div>
            </>
        </Drawer>
    </>
    )   
}